module.exports = __webpack_public_path__ + "img/support-adv-06-logo.b40da4c3.png";